export const LOCAL_STORAGE_KEYS = {
    // Sticky guard for the portal handoff token, which the gateway deletes from
    // Redis on first exchange. Deliberately localStorage and not sessionStorage:
    // the game can re-fire the same deep link into a brand-new webview, where
    // sessionStorage starts empty while the session token is still live.
    PORTAL_REDIRECT_LOGIN_ATTEMPTED: 'ac_portal_redirect_login_attempted',
}
